import React from 'react';
import type { FC } from 'react';
import { Trans } from '@wix/cli-i18n';
import { Link } from '@wix/cli-ui-kit';

export const ContactUs: FC = () => (
  <Trans
    i18nKey="user_feedback.contact_us"
    components={[<Link url="https://discord.gg/wixstudio" />]}
  />
);
